import getTranslatedText from '../../_flux/helper/get_translated_text';

function sortingToOptionLabel({ sorting, direction }) {
    return getTranslatedText(`catalog-sorting-label-${sorting}-${direction}`);
}

export { sortingToOptionLabel };